<template lang="pug">
  .panel-white.body-1.mx-auto
    Modal(:show="confirmModal")
      h1(slot="header") Confirm
      p(slot="body") Are you sure you want to continue with this action?
      .modal-button(slot="buttons")
        button.btn.btn-primary(@click.prevent="confirmAction") Continue
        button.btn.btn-light(@click.prevent="confirmModal = false") Cancel
    .panel-page-white
      .row
        .col
          PageHeader Watch List
      .row.mt-3
        .col
          router-link.btn.btn-primary(to="add_watch") + Add Watch
      .row.mt-3
        .col
          div Bulk Actions
          WatchAction.mt-2(:includeDelete="true" @input="processAction")
        .col
        .col
        .col.body-1
          SearchBar(v-model="filterText")
      .row.mt-3.body-2
        .col
          Datatable(:column-count="8" :entries="filteredWatches" :perPage="6")
            template(slot="header")
              th
                CustomCheckbox(v-model="allCheckbox" @input="toggleAllCheckboxes")
              th.h6 Hits
              th.h6 Last Hit Received
              th.h6 Criteria
              th.h6 Effective Dates
              th.h6 Watch Status
              th.h6 Notes
              th.h6 Actions
            template(slot-scope="props")
              tr
                td
                  CustomCheckbox(:value="!!bulkCheckboxes[props.entry.nplexWatchSid]"
                    @input="processCheck(props.entry.nplexWatchSid)")
                td.no-wrap
                  TinyTag(v-if="props.entry.newHits") New Hits
                  div
                    em(v-if="props.entry.watchHits <= 0") No Hits
                    router-link(v-else :to="{name: 'watch_hits', params: {id: props.entry.nplexWatchSid}}") View Hits
                td.no-wrap {{ props.entry.lastHitReceived  }}
                td
                  div(v-if="watchHasNames(props.entry)")
                    strong Names:
                    |  {{ watchNames(props.entry) }}
                  div(v-if="watchHasBirthDt(props.entry)")
                    strong DOB:
                    |  {{ readableDt(props.entry.birthDt) }}
                  div(v-if="watchHasIds(props.entry)")
                    strong IDs:
                    |  {{ props.entry.ids.join(', ') }}
                  div(v-if="watchHasAddresses(props.entry)")
                    strong Address:
                    div(v-for="address in props.entry.addresses")
                      |  {{ address.address1 }}{{ address.address2 ?  ', ' + address.address2 : '' }}, {{ address.city }}, {{ address.stateCd }} {{ address.postalCode }}
                      br
                  div(v-if="watchHasStates(props.entry)")
                    strong States:
                    |  {{ props.entry.states.join(', ') }}
                td.min-w.no-wrap {{ readableDt(props.entry.creationTs) }}-{{ readableDt(props.entry.expirationTs) }}
                td.min-w.no-wrap {{ activeStatus(props.entry) }}
                td.w-25 {{ props.entry.notes }}
                td
                  WatchAction(
                    :includeEdit="true"
                    :includeDelete="true"
                    :watchId="props.entry.nplexWatchSid"
                    @input="processAction"
                  )
</template>

<script>
import PageHeader from '@/components/PageHeader'
import SearchBar from '@/components/SearchBar'
import WatchAction from '@/components/WatchAction'
import Datatable from '@/components/Datatable'
import CustomCheckbox from '@/components/CustomCheckbox'
import TinyTag from '@/components/TinyTag'
import Modal from '@/components/Modal'
import axios from '@/lib/axios'
import {
  parseDbDt,
  formatDtOnly,
  globalSuccess,
  globalError,
} from '@/lib/utils'

export default {
  name: 'WatchList',
  data() {
    return {
      filterText: '',
      actionOptions: [
        { label: 'Extend 3 months', value: 3 },
        { label: 'Extend 6 months', value: 6 },
        { label: 'Extend 12 months', value: 12 },
      ],
      watches: [],
      bulkCheckboxes: {},
      allCheckbox: false,
      queuedAction: {},
      confirmModal: false,
    }
  },
  methods: {
    parseDbDt,
    formatDtOnly,
    readableDt(dtStr) {
      return dtStr ? formatDtOnly(parseDbDt(dtStr)) : ''
    },
    activeStatus(w) {
      return parseDbDt(w.expirationTs) > new Date() ? 'Active' : 'Not Active'
    },
    toggleAllCheckboxes() {
      for (let key of Object.keys(this.bulkCheckboxes)) {
        this.bulkCheckboxes[key] = this.allCheckbox
      }
    },
    processCheck(id) {
      this.bulkCheckboxes[id] = !this.bulkCheckboxes[id]
    },
    processAction(actionInfo) {
      let ids = [actionInfo.watchId]
      if (actionInfo.watchId === 'bulk') {
        ids = this.bulkSelectedWatchIds
      }
      if (ids.length === 0) return

      if (actionInfo.action === 'edit') {
        this.$router.push({
          name: 'edit_watch',
          params: { watchSid: actionInfo.watchId },
        })
        return
      } else if (actionInfo.action === 'delete') {
        if (!actionInfo.confirmed) {
          Object.assign(this.queuedAction, actionInfo)
          this.confirmModal = true
          return
        }
        axios()
          .post('/api/watches/delete', { watchSids: ids })
          .then(() => {
            axios()
              .get('/api/watches')
              .then(resp => (this.watches = resp.data))
              .catch(err => globalError(err))
            globalSuccess(null, 'Watch(es) successfully deleted')
            scrollTo(0, 0)
          })
          .catch(err => globalError(err))
        axios()
          .put('api/watch/watch_status', { watchSids: ids })
          .catch(err => globalError(err))
        return
      } else if ([3, 6, 12].includes(actionInfo.action)) {
        if (!actionInfo.confirmed) {
          Object.assign(this.queuedAction, actionInfo)
          this.confirmModal = true
          return
        }
        axios()
          .post('/api/watches/extend', {
            watchSids: ids,
            interval: actionInfo.action,
          })
          .then(() => {
            axios()
              .get('/api/watches')
              .then(resp => (this.watches = resp.data))
              .catch(err => globalError(err))
            globalSuccess(null, 'Watch(es) successfully updated')
            scrollTo(0, 0)
          })
          .catch(err => globalError(err))
      }
    },
    confirmAction() {
      this.confirmModal = false
      this.$set(this.queuedAction, 'confirmed', true)
      this.processAction(this.queuedAction)
    },
    watchHasBirthDt(w) {
      return !!w.birthDt
    },
    watchHasNames(w) {
      return (
        w.names.filter(wn => wn.firstName || wn.lastName || wn.middleName)
          .length > 0
      )
    },
    watchNames(w) {
      return w.names
        .map(
          n =>
            `${n.lastName}, ${n.firstName}${
              n.middleName ? ' ' + n.middleName : ''
            }`,
        )
        .join('; ')
    },
    watchHasAddresses(w) {
      return (
        w.addresses.length > 0 &&
        w.addresses.some(
          a => a.address1 || a.address2 || a.city || a.stateCd || a.postalCode,
        )
      )
    },
    watchHasStates(w) {
      return w.states.length > 0
    },
    watchHasIds(w) {
      return w.ids.length > 0 && w.ids.some(a => a)
    },
  },
  computed: {
    bulkSelectedWatchIds() {
      let ids = []
      for (let k in this.bulkCheckboxes)
        if (this.bulkCheckboxes[k]) ids.push(parseInt(k))
      return ids
    },
    filteredWatches() {
      let ft = this.filterText
        .toLowerCase()
        .replace(/^\s+/g, '')
        .replace(/\s+$/, '')
      if (!ft) return this.watches
      let ws = []
      for (let w of this.watches) {
        const name = w.names
          .map(n => n.firstName + n.lastName + n.middleName)
          .join('')
          .toLowerCase()
        const ids = w.ids.join(' ').toLowerCase()
        const a = w.addresses[0]
        const address = a
          ? a.address1 + a.address2 + a.city + a.stateCd + a.postalCode
          : ''
        const states = w.states.join('').toLowerCase()
        if (w.notes && w.notes.toLowerCase().includes(ft)) ws.push(w)
        else if (w.birthDt && w.birthDt.includes(ft)) ws.push(w)
        else if (w.creationTs && w.creationTs.includes(ft)) ws.push(w)
        else if (w.expirationTs && w.expirationTs.includes(ft)) ws.push(w)
        else if (name && name.includes(ft)) ws.push(w)
        else if (ids && ids.includes(ft)) ws.push(w)
        else if (address && address.toLowerCase().includes(ft)) ws.push(w)
        else if (states && states.includes(ft)) ws.push(w)
        else if (
          w.lastHitReceived &&
          w.lastHitReceived.toLowerCase().includes(ft)
        )
          ws.push(w)
        else if (
          this.activeStatus(w)
            .toLowerCase()
            .includes(ft)
        )
          ws.push(w)
      }
      return ws
    },
  },
  watch: {
    watches(val) {
      let newChecks = {}
      for (let w of val) newChecks[w.nplexWatchSid] = false
      this.bulkCheckboxes = newChecks
      this.allCheckbox = false
    },
  },
  beforeRouteEnter(_to, _from, next) {
    axios()
      .get('/api/watches')
      .then(resp => {
        next(vm => (vm.watches = resp.data))
      })
      .catch(err => globalError(err))
  },
  mounted() {
    scrollTo(0, 0)
  },
  components: {
    PageHeader,
    SearchBar,
    WatchAction,
    Datatable,
    CustomCheckbox,
    TinyTag,
    Modal,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints';
.panel-white {
  width: 1007px;
}

.min-w {
  width: 1%;
}

.no-wrap {
  white-space: nowrap;
}
</style>
